var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"azcon-training-card-skeleton"},[_c('div',{staticClass:"azcon-training-card-skeleton__image"}),_c('div',{staticClass:"azcon-training-card-skeleton__title"})])
}]

export { render, staticRenderFns }